import { PropsCell } from '../common/Table/TableHeader';

export const headCells: PropsCell[] = [
  { id: 'id', numeric: false, disablePadding: false, label: 'ID' },
  {
    id: 'warehouses_id',
    numeric: false,
    disablePadding: false,
    label: 'Almacen',
  },
  { id: 'rack', numeric: false, disablePadding: false, label: 'Rack' },
  { id: 'drawer_row', numeric: false, disablePadding: false, label: 'Fila' },
  {
    id: 'drawer_column',
    numeric: false,
    disablePadding: false,
    label: 'Columna',
  },
  {
    id: 'state_drawer',
    numeric: false,
    disablePadding: false,
    label: 'Estado de Gaveta',
  },
  {
    id: 'barcode',
    numeric: false,
    disablePadding: false,
    label: 'Código',
    center: true,
  },
  {
    id: 'status_drawers_id',
    numeric: false,
    disablePadding: false,
    label: 'Activo',
  },
  { id: 'actions', numeric: true, disablePadding: false, label: 'Acciones' },
];

export const fieldsFilter = [
  { key: 'id', name: 'Id de Gaveta' },
  { key: 'warehouses_id', name: 'Código de almacen' },
  { key: 'barcode', name: 'Código de barras' },
  { key: 'rack', name: 'Rack' },
  { key: 'drawer_row', name: 'Fila' },
  { key: 'drawer_column', name: 'Columna' },
];
